<template>
  <div class="helpcontent">
    <div class="header" v-if="$route.query.pt == 'app'">
      <van-icon name="arrow-left" size="0.2rem" color="#222222" @click="goBack"/>
      <div class="text">问题详情</div>
    </div>
    <!--:style="$route.query.pt == 'app' ? {'padding-top': '0.64rem'} : {'padding-top': '0'}"-->
    <div class="content" :style="$route.query.pt == 'app' ? {'padding-top': '0.64rem'} : {'padding-top': '0'}">
      <!--<div class="downloadApp" v-if="$route.query.id == 0 && $route.query.idson == 0">-->
        <!--<van-tabs v-model="active1" swipeable>-->
          <!--<van-tab v-for="(item, index) of downloadApp" :key="index" :title="item.tag">-->
            <!--<p>如何正确下载新版APP？</p>-->
            <!--<div class="link prompt" v-if="index == 0">-->
              <!--<span>可以通过以下方法下载：</span>-->
              <!--<b>1.手机APP内下载</b>-->
              <!--<b>点击链接<a href="http://shop.ckc8.com/DL.html" style="text-decoration: underline;color: #4A90E2;">http://shop.ckc8.com/DL.html</a>直接下载</b>-->
              <!--<b>2.微信内打开链接下载</b>-->
              <!--<b>点击链接<a href="http://shop.ckc8.com/DL.html" style="text-decoration: underline;color: #4A90E2;">http://shop.ckc8.com/DL.html</a>直接下载</b>-->
            <!--</div>-->
            <!--<img :src="item.img">-->
          <!--</van-tab>-->
        <!--</van-tabs>-->
      <!--</div>-->
      <div class="buygoods" v-if="$route.query.id == 0 && $route.query.idson == 0">
        <p>如何购买商品？</p>
        <ul>
          <li v-for="(item, index) of buyGoods" :key="index"><van-icon name="circle" size="0.13rem" color="#59CCB2"/>{{item}}</li>
        </ul>
        <div class="prompt">
          <span>温馨提示：</span>
          <b>1.地址信息可用选择之前保存地址，也可以添加新地址信息</b>
          <b>2.支付多种支付方式，请您选择合适的方式进行支付</b>
        </div>
      </div>
      <div class="kefu" v-else-if="$route.query.id == 0 && $route.query.idson == 1">
        <p>如何联系客服？</p>
        <div class="prompt">
          <span>可以通过以下方式联系客服：</span>
          <b>1.进入首页-->点击客服，即可与店主随时沟通交流</b>
          <b>2.点击分类-->点击列表右上角客服，即可与店主随时沟通交</b>
          <b>3.点击分类-->进入商品详情页-->点击左下角客服，即可与店主随时沟通交流。</b>
          <b>4.点击购物车->点击右上角客服，即可与店主随时沟通交流。</b>
        </div>
        <img src="../../assets/images/help/kefu1.png">
      </div>
      <div class="pay" v-else-if="$route.query.id == 0 && $route.query.idson == 2">
        <p>商城支付方式说明</p>
        <div class="prompt">
          <b style="margin-bottom: 0.26rem">用户购买我们的商品目前可以通过创客云商商城App、微信商城或WAP商城三个通道下单，各个通道分别为您提供了一下的支付方式</b>
          <b>1.创客云商商城APP<br/>支付宝支付、京东支付、银联支付</b>
          <b>2.微信商城<br/>银联支付、微信支付</b>
          <b>3.WAP商城<br/>支付宝支付、京东支付、银联支付</b>
        </div>
      </div>
      <div class="update" v-else-if="$route.query.id == 1 && $route.query.idson == 0">
        <p>如何变更订单收货地址？</p>
        <div class="prompt">
          <span style="margin-bottom: 0.15rem">1.可修改收货地址时间：</span>
          <b style="margin-bottom: 0.23rem">(1）待付款状态订单：一直可以修改收货地址；<br/>(2）已付款订单：支付成功30分钟内可以修改收货地址</b>
          <span style="margin-bottom: 0.15rem">2. 修改收货地址方法：</span>
          <b>我-->待付款订单/待收货订单-->订单详情-->修改地址-->选择新的收货地址</b>
        </div>
        <img src="../../assets/images/help/updateaddress1.png">
      </div>
      <div class="update" v-else-if="$route.query.id == 1 && $route.query.idson == 1">
        <p>如何查看物流信息？</p>
        <div class="prompt">
          <span style="margin-bottom: 0.15rem">查看物流信息的方法如下：</span>
          <b>点击我的->点击订单->选择您要查询的订单，点击订单进入详情->点查看物流</b>
        </div>
        <img src="../../assets/images/help/logistics1.png?v=1">
      </div>
      <div class="update" v-else-if="$route.query.id == 2 && $route.query.idson == 0">
        <p>发货时间</p>
        <div class="prompt">
          <b>1.我们会在订单支付成功后1-3天内发货 (节假日顺延, 部分特殊商品七天内发货) , 送达时间视快递配送时间而定</b>
          <b>2.如遇不可抗力因素, 配送到达时间可能略有延迟</b>
          <b>3.由于商品大小不同, 一个订单中的商品可能会被拆分为多个包裹配送。不同的包裹配送时间会略有不同</b>
          <b>4.包裹发出后, 系统将物流信息更新至顾客的订单信息中, 顾客可通过"我－我的订单"追踪包裹</b>
          <b>5.预售商品的发货时间根据购买商品公示的发货时间进行发货</b>
        </div>
      </div>
      <div class="update" v-else-if="$route.query.id == 2 && $route.query.idson == 1">
        <p>配送范围及运费</p>
        <div class="prompt">
          <span style="margin-bottom: 0.15rem">配送范围</span>
          <b style="margin-bottom: 0.23rem">创客村配送范围覆盖全国大部分地区 (商品不支持配送港澳台地区)</b>
          <span style="margin-bottom: 0.15rem">配送费用</span>
          <b style="margin-bottom: 0.23rem">一般情况下，订单均不收取快递费用，默认发送中通快递，申通快递及百世汇通快递，若向使用其他快递需要支付快递费用。<br/>
            偏远地区会适当的收取一定的运费，具体运费金额以支付时显示的运费进行收取，请注意查看订单确认页显示的配送费用</b>
        </div>
      </div>
      <div class="update" v-else-if="$route.query.id == 2 && $route.query.idson == 2">
        <p>商品验货与签收</p>
        <div class="prompt">
          <b style="margin-bottom: 0.23rem">1.创客村保证出货时货物外包装的完好无缺</b>
          <b style="margin-bottom: 0.23rem">2.为了保证顾客的利益, 请顾客在收到货物时务必验货, 请拆开包装箱, 确认货品完好无损后再签收</b>
          <b style="margin-bottom: 0.23rem">3.如果发现货物在运输途中有破损, 顾客有权拒收, 在快递单上写明拒收原因, 请配送人员退回</b>
          <b style="margin-bottom: 0.23rem">4.若签收后发现有货物损坏、商品有缺件或丢件, 请在签收时间72小时内联系客服处理。超过24小时, 创客村概不负责</b>
        </div>
      </div>
      <div class="update" v-else-if="$route.query.id == 3 && $route.query.idson == 0">
        <p>售后处理范畴</p>
        <div class="prompt">
          <span style="margin-bottom: 0.15rem">商品申请售后注意事项</span>
          <b style="margin-bottom: 0.23rem">1.收到产品后第一时间检查产品，如有任何异常，请进入商城，联系客服，以便第一时间受理。<br/>
            2.售后处理范畴：<br/>
            自售出之日（以实际收货日期为准）起7日内可以退货，15日内可以换货。买家超出规定时限提出退换货申请的，不予处理。<br/>
            原包装不完整（密封产品原包装打开，一次性封贴或胶条破损，原包装指商品的出厂原配包装，不包括物流的二次包装）；影响二次销售的，不予处理</b>
          <span style="margin-bottom: 0.15rem">退换货政策</span>
          <b style="margin-bottom: 0.23rem">1.退款退货 产品未拆封、不影响二次销售<br/>
            2.换货 收到商品存在破损、污渍、不能正常使用</b>
          <span style="margin-bottom: 0.15rem">退货流程</span>
          <b style="margin-bottom: 0.23rem">1.未发货退款
            ①发货前买家联系客服<br/>
            ②提供订单号<br/>
            ③退款将在1-3个工作日原路退回<br/>
            2.已发货退货退款<br/>
            ①提供订单号<br/>
            ②买家确认收货<br/>
            ③申请退款<br/>
            ④退回宝贝<br/>
            ⑤宝贝核实后将在1-3个作日原路退回</b>
          <span style="margin-bottom: 0.15rem">运费问题</span>
          <b style="margin-bottom: 0.23rem">一、退换货运费承担范围：<br/>
            1.因商品质量问题产生的退货，退货运费由公司承担。<br/>
            2.因您个人原因产生的退货，退货运费由您个人承担。<br/>
            二、退换运费申请途径：<br/>
            1.请联系客服，沟通退运费事宜;<br/>
            2.退运费需要提供商品订单号、退回快递面单照片及运费金额、申请人姓名、电话信息给客服；<br/>
            3.运费受理日期为：周一至周五（8：30---17：30）进行，请悉知，感谢您的配合！<br/>
            温馨提示：不支持到付、不支持EMS、不支持顺丰哦！</b>
          <span style="margin-bottom: 0.15rem">退货地址</span>
          <b style="margin-bottom: 0.23rem">退货地址：陕西省西安市长安区上林苑九路555号16号楼创客云商<br/>
            也可在App售后页面查看退货地址<br/>
            单位名称：西安创客村电子商务有限责任公司<br/>
            电话：18092558321<br/>
            (退换货寄回时拿张纸条将订单号和退货理由说明，如果是退货退款要保证货物完好无损哦)</b>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import { Tab, Tabs } from 'vant'
import { isWeixin, fenxiang } from '../../assets/common/js/config'

Vue.use(Tab).use(Tabs)
export default {
  name: 'helpContent',
  data () {
    return {
      active1: 0,
      downloadApp: [
        {
          tag: '链接下载',
          img: require('../../assets/images/help/link1.png')
        },
        {
          tag: '苹果手机',
          img: require('../../assets/images/help/apple1.png')
        },
        {
          tag: '安卓手机',
          img: require('../../assets/images/help/android1.png')
        }
      ],
      buyGoods: ['下载商城APP', '打开移动商城', '登录', '选择产品', '立刻购买', '编辑收货信息', '提交订单', '支付']
    }
  },
  mounted () {
    if (isWeixin()) {
      fenxiang({path: 'helpcontent'})
    }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="scss">
  .helpcontent .header {
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    display: -o-flex;
    display: -ms-flex;
    align-items: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    -o-align-items: center;
    -ms-align-items: center;
  }
  .helpcontent .content .downloadApp .prompt, .helpcontent .content .buygoods .prompt, .helpcontent .content .kefu .prompt, .helpcontent .content .pay .prompt, .helpcontent .content .update .prompt{
    font-size:0.15rem;
    span {
      font-size:0.15rem;
      font-weight:600;
      color:rgba(75,75,75,1);
      line-height:0.21rem;
      display: block;
    }
    b {
      font-size:0.15rem;
      font-weight:400;
      color:rgba(75,75,75,1);
      line-height:0.21rem;
      display: block;
      margin-bottom: 0.13rem;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
  .helpcontent {
  background: #fff;
  padding: 0 0.15rem;
  .header {
    height: 0.64rem;
    background: #fff;
    padding: 0 0.06rem;
    padding-top: 0.2rem;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 100;
    .text {
      flex: 1;
      -webkit-flex: 1;
      -moz-flex: 1;
      -o-flex: 1;
      -ms-flex: 1;
      text-align: center;
      font-size:0.17rem;
      font-weight:400;
      color:rgba(34,34,34,1);
      line-height:0.24rem;
    }
  }
  .content {
    p {
      font-size:0.17rem;
      font-weight:600;
      color:rgba(75,75,75,1);
      line-height:0.24rem;
      padding: 0.21rem 0 0.2rem;
      margin-bottom: 0.23rem;
      border-bottom: 0.01rem solid #EFEFEF;
    }
    .downloadApp {
      .link {
        margin-bottom: 0.56rem;
        span {
          margin-bottom: 0.15rem;
        }
        b {
          margin-top: 0.04rem;
          &:first-of-type {
            margin-top: 0;
          }
          &:nth-of-type(3) {
            margin-top: 0.13rem;
          }
        }
      }
      img {
        width: 100%;
        padding: 0 0.18rem;
      }
    }
    .buygoods {
      ul {
        padding: 0 0.15rem;
        li {
          font-size:0.15rem;
          font-weight:600;
          color:rgba(75,75,75,1);
          line-height:0.21rem;
          border-left: 0.01rem solid #D8D8D8;
          padding-bottom: 0.2rem;
          &:last-of-type {
            padding-bottom: 0;
          }
          .van-icon {
            position: relative;
            left: -0.065rem;
            background: #fff;
            font-weight: 600;
            padding: 0.06rem 0;
            padding-right: 0.15rem;
          }
        }
      }
      .prompt {
        padding-top: 0.41rem;
        padding-bottom: 0.46rem;
      }
    }
    .kefu {
      .prompt {
        padding-bottom: 0.34rem;
      }
      img {
        width: 100%;
        padding: 0 0.14rem 0.32rem;
      }
    }
    .update {
      .prompt {
        padding-bottom: 0.37rem;
      }
      img {
        width: 100%;
        padding: 0 0.14rem 0.52rem;
      }
    }
  }
}
</style>
<style lang="scss">
  .content {
    .van-tabs__wrap {
      position: fixed;
      left: 0;
      right: 0;
    }
    .van-tabs__content {
      padding-top: 0.44rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/user/helpContent.vue